import { observable, action, autorunAsync } from "mobx";
import { Promise } from 'es6-promise';
import { StateStorage } from "./StateStorage"


/**
 * Load and store all observable properties.
 * Do not set initialization values in derived classes!
 */
export abstract class PersistentStore {

	private loaded = false;
	private autoSave: any;
	private readonly storageKey: string;

	constructor(storageKey: string) {
		this.storageKey = storageKey;
	}

	public loadSync(): void {
		let json: string = StateStorage.getData(this.storageKey);
		if (json) {
			let data: any = JSON.parse(json);
			let me: any = this;
			let keys = Object.getOwnPropertyNames(data);
			keys.map(key => {
				let value = data[key];
				if (value) {
					if (key in me) {
						me[key] = value;
					}
				}
			});
		}
		this.loaded = true;
		this.autoSave = autorunAsync(`Automatically persist data with key '${this.storageKey}' to store`, () => {
			this.save();
		});
	}

	public loadAsync(): Promise<void> {
		return new Promise<void>((resolve: () => void, reject: (error: string) => void) => {
			try {
				this.loadSync();
			}
			catch (ex) {
				reject(ex);
			}
		});
	}

	private save(): void {
		if (this.loaded) {
			let data: any = {};
			let me: any = this;
			let keys = Object.getOwnPropertyNames(this);
			keys.map(key => {
				let thisProperty = Object.getOwnPropertyDescriptor(this, key);
				if (thisProperty && thisProperty.get && thisProperty.set) {
					let value: any = me[key];
					if (value) {
						data[key] = value;
					}
				}
			});
			let json = JSON.stringify(data);
			StateStorage.saveData(this.storageKey, json);
		}
	}

}

